import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../queryKeys';
import { order } from '../Order';

export const useOrderSummary = () =>
  useQuery({
    queryKey: [QUERY_KEYS.orderSummary],
    queryFn: async () => (await order.getOrderSummary()).data,
  });
